module.exports = __webpack_public_path__ + "img/bottomArrow.bba21066.svg";